import { gql } from 'apollo-angular';

export const customerIdentQuery = gql`
  query getCustomerIdent {
    getCustomerIdent {
      customerIdent
    }
  }
`;
